import { IconButton } from '@material-ui/core';
import Svg from 'components/UI/Svg/Svg';
import { Color } from 'modules/styles/colors';
import React, { useState } from 'react';
import {
  MuiBox,
  MuiDialog,
  MuiLink,
  MuiList,
  MuiListItem,
  MuiListItemText,
  MuiTypography
} from '../../theme/material-ui';

import { IconSize, ZIndex } from 'modules/styles/variables';
import { Spacing } from 'modules/styles/variables.web';
import { useHistory } from 'react-router';
import analyticsService, { AnalyticsEvent } from 'services/AnalyticsService';
import HealthRecordsSummary from 'screens/HealthRecords/HealthRecordsSummary';

function NewAppAnnouncementDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const history = useHistory();
  const [isHealthSummaryModalOpen, setIsHealthSummaryModalOpen] = useState(false);
  const openHealthRecondSummary = () => {
    analyticsService.logEvent(AnalyticsEvent.ETDashboardHealthRecordSummaryClicked);
    setIsHealthSummaryModalOpen(true);
  };
  const openMessagesHome = () => {
    analyticsService.logEvent(AnalyticsEvent.ETDashboardProviderMessagesButtonClicked);
    history.push('/u/messages');
  };
  const onLearnMorePress = () => {
    analyticsService.logEvent(AnalyticsEvent.ETDashboardLearnMoreLinkClicked);
    window.open(
      'https://intermountainhealthcare.org/for-patients/transition-faq',
      '_blank',
      'noopener'
    );
  };

  const closeHealthSummaryModal = () => {
    setIsHealthSummaryModalOpen(false);
  };
  return (
    <MuiDialog open={open} maxWidth="md" onClose={onClose}>
      <HealthRecordsSummary
        displayMode="modal"
        isModalOpen={isHealthSummaryModalOpen}
        onModalClose={closeHealthSummaryModal}
        modalTitle="Health Records Summary"
      />
      <MuiBox
        width="100%"
        height="15px"
        bgcolor={Color.secondary}
        position="absolute"
        top={0}
        left={0}
      />
      <MuiBox position="absolute" top={10} right={5} zIndex={ZIndex.high}>
        <IconButton
          onClick={onClose}
          aria-label="close connect care modal"
          data-testid="close-modal-icon"
        >
          <Svg set="material" name="close" size={IconSize.base} />
        </IconButton>
      </MuiBox>
      <MuiBox display="flex" flexDirection="column" alignItems="flex-start" top={10} p={6}>
        <MuiBox bottom={Spacing.large} data-testid="description">
          <MuiBox top={Spacing.large}>
            <MuiTypography fontSize={16}>
              Coming soon - new and improved access to your health records, lab results, appointment
              scheduling, provider messaging, bill management and other tools to manage your health.
            </MuiTypography>
          </MuiBox>
          <MuiBox top={Spacing.largeXLarge}>
            <MuiTypography fontSize={16} fontWeight="bold">
              Get Ready Now
            </MuiTypography>
            <MuiBox>
              <MuiList>
                <MuiListItem alignItems="flex-start">
                  <MuiBox display="flex" flexDirection="column" width="100%">
                    <MuiListItemText
                      primary={
                        <>
                          1. Download your{' '}
                          <MuiLink
                            component="button"
                            onClick={openHealthRecondSummary}
                            style={{
                              cursor: 'pointer',
                              fontWeight: 500,
                              textDecoration: 'underline'
                            }}
                          >
                            Health Record Summary
                          </MuiLink>
                          *
                        </>
                      }
                    />
                  </MuiBox>
                </MuiListItem>
                <MuiListItem alignItems="flex-start">
                  <MuiBox display="flex" flexDirection="column" width="100%">
                    <MuiListItemText
                      primary={
                        <>
                          2. Download{' '}
                          <MuiLink
                            component="button"
                            onClick={openMessagesHome}
                            style={{
                              cursor: 'pointer',
                              fontWeight: 500,
                              textDecoration: 'underline'
                            }}
                          >
                            provider messages
                          </MuiLink>{' '}
                          you want to save**
                        </>
                      }
                    />
                  </MuiBox>
                </MuiListItem>
                <MuiListItem alignItems="flex-start">
                  <MuiBox display="flex" flexDirection="column">
                    <MuiListItemText
                      primary={
                        <>
                          3.{' '}
                          <MuiLink
                            component="button"
                            onClick={onLearnMorePress}
                            style={{
                              cursor: 'pointer',
                              fontWeight: 500,
                              textDecoration: 'underline'
                            }}
                          >
                            Learn more
                          </MuiLink>{' '}
                          about the new Intermountain Health app
                        </>
                      }
                    />
                  </MuiBox>
                </MuiListItem>
              </MuiList>
            </MuiBox>
            <hr style={{ width: '100%', margin: `${Spacing.large}px 0` }} />
            <MuiBox display="flex" flexDirection="row" alignItems="flex-start" mb={Spacing.xSmall}>
              <MuiBox paddingRight={1}>
                <Svg set="assets" name="InfoIcon" size={IconSize.base} color={Color.black} />
              </MuiBox>
              <MuiTypography fontSize={14}>
                *The new Intermountain Health app powered by MyChart will display up to the last
                three to five years of patient health records. You can download your older health
                records from the Health Record Summary in the Health Record section, before the
                switch to the new app.
              </MuiTypography>
            </MuiBox>
            <MuiBox display="flex" flexDirection="row" alignItems="flex-start">
              <MuiBox paddingRight={1}>
                <Svg set="assets" name="InfoIcon" size={IconSize.base} color={Color.black} />
              </MuiBox>
              <MuiTypography fontSize={14}>
                **Provider and other messages sent and received in the current Intermountain Health
                patient portal will not be shown in the new app. You can save any messages you want
                to keep before the switch to the new app.
              </MuiTypography>
            </MuiBox>
          </MuiBox>
        </MuiBox>
      </MuiBox>
    </MuiDialog>
  );
}

export default NewAppAnnouncementDialog;
